import React from "react";
import LogoAprendro from "../images/aprendoencasa.png";
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "./Drawer";
import PropTypes from "prop-types";

const Banner = ({ number, color }) => {
  const useStyles = makeStyles((theme) => ({
    content: {
      background: "#e6e7e8",
      height: 60,
      display: "flex",
      width: "100%",
      fontFamily: "Gotham Rounded",
    },
    contentNumber: {
      background: theme.palette[color].main,
      color: "#fff",
      width: 60,
      fontSize: 30,
      fontWeight: 600,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    rootLamina: {
      marginTop: 120,
    },
    contentBanner: {
      marginLeft: 10,
      marginRight: 10,
      display: "flex",
      width: "100%",
      justifyContent: "space-between",
      alignItems: "center",
      "& h2": {
        width: 50,
        fontSize: 16,
        fontWeight: 600,
      },
    },
    menu: {
      width: 200,
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      textAlign: "right",
      "& i": {
        fontSize: 20,
      },
      "& img": {
        [theme.breakpoints.down("xs")]: {
          display: "none",
        },
      },
    },
  }));
  const classes = useStyles();
  return (
    <div className={classes.content}>
      <div className={classes.contentNumber}>{number}</div>
      <div className={classes.contentBanner}>
        <a
          href="https://fundacionmohme.org/especiales/ciudadania-activa/"
          style={{ color: "inherit", textDecoration: "none" }}
        >
          <h2>Ciudadanía activa</h2>
        </a>
        <div className={classes.menu}>
          <img src={LogoAprendro} alt="Aprendo en casa" />
          <Drawer />
        </div>
      </div>
    </div>
  );
};

Banner.propTypes = {
  color: PropTypes.string,
  number: PropTypes.string,
};

export default Banner;
